module.exports = __webpack_public_path__ + "img/Privacy.3b311812.svg";